import {
	Component,
	OnInit,
	ComponentFactoryResolver,
	ViewChild,
	AfterViewInit,
	ElementRef,
	OnDestroy,
	inject,
	Injector,
} from "@angular/core";
import {
	UserPermissionServiceProxy,
	SelectListItemDto,
	ProductServiceProxy,
	ProductDto,
	OrderServiceProxy,
	CreateOrderDto,
	AddressServiceProxy,
	AddressSimilarityResultDto,
	AddressSimilarityDto,
	WarehouseSelectListDto,
	AddressDto,
	OrderNewAddressDto,
	DamageStatusType,
	UserFormsServiceProxy,
	ShipmentTypeDto,
	UserFormOrderFormTypeDto,
	UserPermissionFormAuthorizationDto,
	UserProductAttributeServiceProxy,
	UserProductAttributeDto,
	ProductAttributeServiceProxy,
	ProductAttributeDto,
	ProductDamageStatusServiceProxy,
	ProductDamageStatusDto,
	ComponentType3,
} from "../../../../../../../shared/service-proxies/service-proxies";
import { BehaviorSubject, Subscription, merge, fromEvent, Observable, of, combineLatest } from "rxjs";
import { ComponentViewDirective } from "./cmp-directive";
import { OrderService } from "../../services/order-service";
import {
	MatDialog,
	MatPaginator
} from "@angular/material";
import { tap, debounceTime, distinctUntilChanged } from "rxjs/operators";
import { FilterForProduct } from "../../../stock/data-source/product-data-source";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddressSimilarityModalComponent } from './address-similarity-modal/address-similarity-modal.component';
import { ImageModalComponent } from './image-modal/image-modal.component';
import { TestService } from '../../../../../../../test/service/test.service';
import { extend } from 'webdriver-js-extender';
import { AppComponentBase } from '../../../../../../../shared/app-component-base';
import { ActivatedRoute } from '@angular/router';
import { AppSessionService } from '@shared/session/app-session.service';
import { ShoppingCardService } from '../step3/services/shopping-card.service'
import { select } from '@ngrx/store';
import { SktLotModalComponent } from './skt-lot-modal/skt-lot-modal.component';
import { sum } from 'lodash';
import { SpinnerService } from '../../../shared/spinner.service';
import { SpecialCodeModalComponent } from './special-code-modal/special-code-modal.component';
import { InsufficientStockModalComponent } from './insufficient-stock-modal/insufficient-stock-modal.component';
import { ApplicationError } from '@shared/services/appplication-error.model';
import { CustomLocalizationService } from '../../../utility/customLocalization.service';
import { AppConsts } from "@shared/AppConsts";
import { ComponentViewTopDirective } from "./cmp-top.directive";
//import { ApplicationError } from '@shared/services/appplication-error.model';

@Component({
	selector: "kt-step3",
	templateUrl: "./step3.component.html",
	styleUrls: ["./step3.component.scss"],
})
export class Step3Component extends AppComponentBase implements OnInit, OnDestroy {

	//product tablosunun üzerinde ki arama yerinin id sine bağlı olarak element bilgilerini yakalar.
	@ViewChild("searchInput", { static: true }) searchInput: ElementRef;

	//ComponentViewDirective directivinin içerisinde ki değerleri alır ve biz burada viewContainer olarak kullanmak istiyoruz
	@ViewChild(ComponentViewDirective, { static: true }) orderHost;

	//ekranin en ustune dinamik olarak yuklenecek componentler icin holder... (Ornek: transfer component)
	@ViewChild(ComponentViewTopDirective, { static: true }) orderTopHost;

	////Product tablosunda ki ürünleri sıralamak için id 'si sort1 olan elementi MatSort formatında aldık.
	//@ViewChild("sort1", { static: true }) sort: MatSort;

	//Product tablosunun altında ki paginatoru ve orada ki görinen tüm dataları yakalarız.
	//Ürün listesinin 5 li ya da 10 lı görünmesi gibi sayfalama işlemlerini yapar.
	@ViewChild("paginatorBottom", { static: true }) paginatorBottom: MatPaginator;


	//Talep yapılan deponun listesini tutar.
	requestedWarehouseList = new BehaviorSubject<WarehouseSelectListDto[]>([]);

	//Ürün listesi tutar.
	products$ = new BehaviorSubject<ProductDto[]>([]);
	productList: ProductDto[] = []; 

	//Ürün listesinin toplam sayısını tutar.
	totalCount$ = new BehaviorSubject<number>(0);

	//Paginatorun bulunduğu spinner aktif ya da pasif yapar.
	loading$ = new BehaviorSubject<boolean>(false);

	//Yüklencek olacan dinamic componentin adını tutar.
	componentName = new BehaviorSubject<string>("");

	////butonlarda spinner görünğr ya da gizli yapmak için kullanılır.
	//loading = new BehaviorSubject<boolean>(false);

	//Depoya ait ürün yok ise altta mesaj göstermek için kullanıyoruz.
	productNotFound = new BehaviorSubject<boolean>(null);


	//Kullanının stok görme yetkisini tutar eğer yetkisi yoksa başka ürünlerde stok miktarı gösterilmeyecek.
	isStokView = new BehaviorSubject<boolean>(false);

	private subscriptions: Subscription[] = [];
	filterParams: FilterForProduct;

	//Ürün listesi gizlemek için kullanıyoruz.
	isproductList = new BehaviorSubject<boolean>(false);

	//depo kodu listeyi çekerken gerekli bir parametre
	wareHouseCode: string;

	keyword = "";

	//Talep yapılan deponun içerisinden şeçilmiş olan deponun bilgilerini tutar
	selectedRequestedWareHouseObj;

	//dinamic component içerisinden gelen dataları tutar.
	dynamicCmpObject;

	//talep yapılan deponun combobox'ı seçilmediğinde ekranda görinecek hata mesajı
	isRequiredRequestedWareHouseMessage = new BehaviorSubject<boolean>(null);
	// Step2 ekranında karta ait formId.
	cardFormId : number;
	//
	formShipmentTypes = new BehaviorSubject<ShipmentTypeDto[]>([]);

	// Teslimat tür listesi içerisinde varsayılan seçili olarak gelen değer.
	selectedShipmentType: number;

	// Ürün Hasarlı/Hasarsız combosunda ngModel değeri. 
	// 2 olarak set edilmesinin nedeni ise, Hasarsız item'nın seçili gelmesi içindir.
	orderDamageStatusType = 2;

	//Aciklama alaninin bagli oldugu ngModel degeri.
	comment : string;

	// Kullanıcının form bazındaki yetki objesi
	userFormAuthorization$ = new BehaviorSubject<UserPermissionFormAuthorizationDto>(null);
	
	// Seçili özel kodlu talep varyasyonId
	selectedSpecialCodeVariationCode: string = '-1';
	
	currentForm = new UserFormOrderFormTypeDto();

	public shoppingCartItems$ = new BehaviorSubject<ProductDto[]>([]);
  	//public shoppingCartItems: ProductDto[] = [];

	private routeSub: Subscription;

	//Kullanıcıya atanmış iş birimleri içerisinden seçili olanları yakalar
	selectedBusinessUnitId: number = -1;

	//Kullanıcıya atanmış is birimlerinin listesini asenkron olarak tutarız
	assignedBusinessUnits = new BehaviorSubject<UserProductAttributeDto[]>([]);
	
	//iş birimine göre gelen markalardan seçili olanı yakalar.
	selectedBrandUnitId: number = -1;

	//Kullanıcının seçtiği iş birimine göre markalaın listesini combo içerisine doldururuz
	brandsByBusinessUnits = new BehaviorSubject<ProductAttributeDto[]>([]);

	brandIds = new BehaviorSubject<number[]>([]);

	specialCodes = new BehaviorSubject<string[]>([]);


	infoHide: boolean = true;

	damageStatuses = new BehaviorSubject<ProductDamageStatusDto[]>([]);

	uiLabelsWarehouse = 'FE.ORDER.FORMS.LABELS.COMMON.FROMREQUESTWAREHOUSE';

	/**
	 * Tahmini sevk maliyetini talep oncesi gorebilir mi?
	 */
	isShowTotalShipmentPriceButton : boolean ;

	constructor(
		private _userPermissionService: UserPermissionServiceProxy,
		private orderService: OrderService,
		private _orderService: OrderServiceProxy,
		private componentFactoryResolve: ComponentFactoryResolver,
		private _productService: ProductServiceProxy,
		private modalService: NgbModal,
		private _addressService: AddressServiceProxy,
		private _testService: TestService,
		private _userFormService: UserFormsServiceProxy,
		injector: Injector,
		private route: ActivatedRoute,
		private shoppingCardService: ShoppingCardService,
		private _userProductAttributeService: UserProductAttributeServiceProxy,
		private _productAttributeService: ProductAttributeServiceProxy,
		private _dialog: MatDialog,
		private spinnerService: SpinnerService,
		private _productDamageStatusService: ProductDamageStatusServiceProxy,
		private customLocalization: CustomLocalizationService,
	) {
		super(injector);

		// Datatable filtrelerini server side tarafına göndermek için hazırlanmış olan sınıf.
		this.filterParams = new FilterForProduct();

		this.shoppingCardService.resetItems();

		this.shoppingCartItems$ = this.shoppingCardService.getItems();

		this.isShowTotalShipmentPriceButton = this.appSession.user.isUserCanViewTotalShipmentPrice ;
		//this.shoppingCartItems$.subscribe(_ => this.shoppingCartItems = _);
	}

	ngOnInit(): void {
		
	}

	ngAfterViewInit() {

		this.routeSub = this.route.params.subscribe(params => {
			

			//this.titleAndSubTitle();

			this.cardFormId = +params['id'];

			this.getOrderFormTypeByUserFormAuthorization(this.cardFormId);
		  });

		//product listesi ilk yüklendiği anda 10 tanesi getir diyoruz. Yani ilk 10 ürün gelsin.
		this.paginatorBottom.pageSize = 10;


		//product listesinin Search işleminin yapıldığı method.
		this.productSearchOperation();

		//Porduct listesinin paginator işlemlerinin yapıldığı method.
		this.productPaginatorOperation();

		console.log("Step3 ngOnInit", "true");
		
	}

	btnInfoHide() {
		this.infoHide = !this.infoHide;
	}

	btnSpecialCodeByVariation(productItem, productId) {

		console.log("ürün id si:" + productId);
		var dialogRef = this._dialog.open(SpecialCodeModalComponent, {
			data: {
				specialCode: this.selectedSpecialCodeVariationCode,
				productItem: productItem,
				productId: productId,
				stokView: this.isStokView.value
			}
		})


		dialogRef.afterClosed().subscribe(obj => {

			if (obj) {
				
				this.products$.next(this.productList);

				}
			}
		)

	}


	btnCheckProductSave(productId) {

		var isProduct = this.shoppingCartItems$.getValue().find(x => x.id == productId);

		if (isProduct) {
			return true;

		}

		return false;
	}

	btnClearInCard(productId) {

		this.shoppingCardService.removeProductByProductId(productId);
	}

	private titleAndSubTitle() {

		this.orderService.cardTitleAndSubTitleStep3.subscribe(result => {


			var titleAndSubtitleObj = this.orderService.getOrderTitleAndSubtitleWithSession(result, "cardTitleAndSubTitleObjStep3");

			//console.log("STEP 3 DEKİ TİTLE VE SUBTİTLE DEĞERLERİMİZ: " + titleAndSubtitleObj);

			//card kısmının üzerinde bulunğu talep tipine ait başlık ve alt başlık bilgilerini basar.
			this._testService.setTitle(titleAndSubtitleObj.title);
			this._testService.setDesc(titleAndSubtitleObj.subtitle);
		});

	}


	btnTest() {
		console.log(this.selectedSpecialCodeVariationCode);
		console.log(this.brandIds.getValue());
	}

	onChanceBrandId() {
		if (this.selectedBrandUnitId > 0) {
			var selectBrandIds = [];
			selectBrandIds.push(this.selectedBrandUnitId);
			this.brandIds.next(selectBrandIds);
		}
		else {
			//liste içerisinde ki value arasında sadece id lerin listesini bize dönder diyoruz.
			var brandsIds = this.brandsByBusinessUnits.getValue().map(x => x.id);
			//Marka id lerini tutan listemizdir
			this.brandIds.next(brandsIds);

		}

		this.productLoadList();

	}

	//seçilen iş birimine göre marka listesini getirir. 
	getBrandsByBusinessUnits() {

		//iş birimi eğer hepsi seçilirse arka tarafa tekrar gitmesine gerek yok
		//ortak listemizin içerisini boşaltmamız ve marka combosunun içerisini boşaltmamız yeterli.
		if (this.selectedBusinessUnitId < 1) {

			this.selectedBrandUnitId = -1;
			this.brandIds = new BehaviorSubject<number[]>([]);
			this.brandsByBusinessUnits = new BehaviorSubject<ProductAttributeDto[]>([]);
			return this.productLoadList();
		}
		else {
			
			this._productAttributeService.getBrandsByBusinessUnitId(this.selectedBusinessUnitId)
				.subscribe(result => {
					console.log(result);
					this.brandsByBusinessUnits.next(result);

					var bransList = result.map(x => x.id);
					//Marka id lerini tutan listemizdir
					this.brandIds.next(bransList);

					this.productLoadList();
				})
		}
	}

	//Kullanıcıya atanmış ürünlerde ki combobox içerisinde bir değişiklik yaparsak
	//seçilen ürüne göre iş birimi marka listesini getir diyoruz.
	onChanceBusinessUnit() {
		//Bunun amacı iş birimi her değiştiğinde seçili bir marka varsa eski seçili olan gelmesin,
		//sadece 'Hepsi' yazısı seçili gelsin
		this.selectedBrandUnitId = -1;
		this.getBrandsByBusinessUnits();
		
	}

	btnTestShoppingCards(){
		
		//this.shoppingCardService.addToCart(new ProductDto(1,0,7));
		//this.shoppingCardService.addToCart(new ProductDto(1,4,5));
		//this.shoppingCardService.addToCart(new ProductDto(1,1,10));
	}

	//kullanıcıya atanmış iş birimlerini 
	getUserAssignedProductAttributes() {
		//user id düzenlenecek
		this._userProductAttributeService.getUserAssignedProductAttributesByGlobalFilters()
			.subscribe(result => {
				console.log("iş birimi objesi:" + result);
				this.assignedBusinessUnits.next(result);
			})
	}



	getOrderFormTypeByUserFormAuthorization(formId: number){

		this._userFormService.getOrderFormTypeByUserFormAuthorization(formId)
				.subscribe(orderFormTypeAuth => {
					

					if(orderFormTypeAuth.userHasAuth){


						////////////////////////////////////////
						this.currentForm = orderFormTypeAuth.form;

						//Combine yani birleştirme yöntemi ile methodları önce gönderip tek subscribe içerisinde yakalıyoruz.
						//Burada ki önemli ksım ise spinner olayını kontrol edebiliyoruz çünki subscribe bittiği anda kapat diyoruz spinnerı
						this.getHttpRequestWithCombineLatest(this.currentForm);


						///////////////ESKİ YÖNTEM SPİNNER KESİK OLARAK GELDİĞİ İÇİN ÜSTTEKİ COMBİNE YÖNTEMİNE GEÇİLDİ VE BİR SPİNNER DAHA EKLENDİ ÜSTTEKİ METHODA UYGUN OLARAK////////////////////

						//console.log(orderFormTypeAuth);
						//this.currentForm = orderFormTypeAuth.form;
						////var form = orderFormTypeAuth.form;

						//// Kullanıcının talep yapabileceği depolar listesini comboya dolduran method.
						//this.loadCmbRequestWarehouses();
					
						//// Dinamik olarak component hazırlanır.
						//this.getDynamicComponentByForm(orderFormTypeAuth.form);

						//// Kullanıcının parametre olarak verilen form içerisinde yetkili olduğu teslimat listesini comboya dolduran method
						//this.loadCmbShipmentTypes(this.currentForm.id);

						//// Ürün Hasar combosu yetkisi
						//this.checkUserAuthorizationByForm(this.currentForm.id);

						//this.checkUserStockViewAuth();

					}
					else {

						
						//ön taraftan kaynaklı hataları ile yakalar bir yapıya getirmeliyiz .

						this.errorHandler.setMessage(this.customLocalization.l("FE.PAGES.COMMON.NOTAUTH"));
						throw new ApplicationError();

					}

				});

	}

	localizeText(key:string){
		return this.l(key);
	}

	getHttpRequestWithCombineLatest(form) {

		

		this.spinnerService.isLoadingByOrderPageStep3.next(true);

		//Burada Talep yapılan depolar methoduna git ve bize talep yapıla bilen depolar  listesini al diyoruz.
		const requestWarehouse = this._userPermissionService.getFromRequestWarehouseByUserAuths(form.id);

		//müşterinin yetkili olduğu teslimat tipleri listesini bize ver diyoruz.
		const shipmentTypeList = this._userFormService.getUserCustomerShipmentTypeListByForm(form.id);

		//müşterinin yetkisi var ise ürün hasar listesini yani hasarlı, hasarsız şeklinde bize vermesini istiyoruz.
		const checkUserAuthByForm = this._userPermissionService.checkUserAuthorizationByForm(form.id);

		//müşterinin ürünlerin stok görme yetkisini bize ver diyoruz ve bu yetkiye göre ürün listesinde gösteriyoruz stok adedini.
		const userStokViewInformation = this._userPermissionService.getUserStokViewInformation();
		
		const all$ = combineLatest(requestWarehouse, shipmentTypeList, checkUserAuthByForm, userStokViewInformation);

		all$.subscribe(combineResult => {

			//Talep yapılan depolar listesini basarız.
			//combineResult[0] combineLatest içerisindeki ilk yerin karşılığıdır.
			this.requestedWarehouseList.next(combineResult[0]);

			console.log("Hedef Depolar");
			console.log(combineResult[0]);

			//Burası tamamen sıraya uygun olması için eklendi.
			//dinamic component basıldığı methoddur.
			//spinner bütün methodların işi bitince kapanması için bu methodda combineLatest içerisine alınmıştır.
			this.getDynamicComponentByForm(form);


			//Teslimat tipi comsounu basarız ve default değerini ayarlarız.
			//Teslimat tipi seçili gelmesi gereken değeri ayarlarız
			var defaultType = combineResult[1].find(x => x.isDefault == true);
			this.selectedShipmentType = defaultType.id;

			

			//Teslimt tipi listesidir.
			//combineResult[1] içerisindedir liste.
			this.formShipmentTypes.next(combineResult[1]);
			
			//Bize yetkileri yani yetkili olduğumuz şeyleri verir
			//Mesela özel kodlu talep, iş birimi , hasarlı-hasarsız ürün yetkilerini dönderir biz duruma göre ekrana basarız.
			//combineResult[2] karşılığı checkUserAuthorizationByForm methodudur,
			//combineLatest içerisinde ki 3 sırada ki değerdir.
			this.userFormAuthorization$.next(combineResult[2]);

			//Hasarlı/Hasarsız ürün combosunu dolduruyoruz.
			if (combineResult[2].isOrderDamagedProduct) {
				this.getProductDamageStatusList();
			}

			//Eğer bu form için iş birimi yetkisi varsa bu methodu çalıştır ve
			//atanmış iş birimlerini yükle diyoruz. aksi taktirde görünmeyecek
			//bir combonun methodunu çalıştırma diyoruz
			if (combineResult[2].isOrderByBusinessUnit) {
				this.getUserAssignedProductAttributes();
			}


			//Ürün stok görme yetkisini alıyoruz
			this.isStokView.next(combineResult[3]);

			this.spinnerService.isLoadingByOrderPageStep3.next(false);

		});

	}


	getProductDamageStatusList() {

		this._productDamageStatusService.getAll("", "", 0, 10000).subscribe(result => {
			console.log("HASARLI HASARSIZ ÜRÜN ÇIKTISI: " + result);
			this.damageStatuses.next(result.items);
		});

	}

	loadCmbShipmentTypes(formId: number) {

		//var selectedOrderData = JSON.parse(sessionStorage.getItem("orderObjectStep3"));

		this._userFormService.getUserCustomerShipmentTypeListByForm(formId)
			.subscribe(resp => {
				console.log(resp);

				this.formShipmentTypes.next(resp);

				var defaultType = resp.find(x => x.isDefault == true);
				this.selectedShipmentType = defaultType.id;

		})

	}

	checkUserAuthorizationByForm(formId : number){
		this._userPermissionService.checkUserAuthorizationByForm(formId)
			.subscribe(authorizationObject => {

				this.userFormAuthorization$.next(authorizationObject);

				//Eğer bu form için iş birimi yetkisi varsa bu methodu çalıştır ve
				//atanmış iş birimlerini yükle diyoruz. aksi taktirde görünmeyecek
				//bir combonun methodunu çalıştırma diyoruz
				if (authorizationObject.isOrderByBusinessUnit) {
					this.getUserAssignedProductAttributes();
				}
				
			});
	}


	//Bunun amacı bazı müşterilere daha farklı bir ekran sağlamak
	//ürün listesini bu kodlara göre filtrelemek ve bu comboda ki datalara göre ürünleri ekrana basmak.
	getDistinctSpecialCodesFromWarehousesProductList() {

		var warehouseId = this.selectedRequestedWareHouseObj.id;
		var warehouseCode = this.wareHouseCode;
		//var remoteWarehouseId = this.selectedRequestedWareHouseObj.remoteWarehouseId;

		this._productService.getDistinctSpecialCodesFromWarehousesProductList(
			warehouseId,
			warehouseCode,
			//remoteWarehouseId,
			this.orderDamageStatusType
		).subscribe(result => {

			console.log(result);
			this.specialCodes.next(result);
		});

	}


	onChangeSpecialCode() {

		this.shoppingCardService.resetItems();
		this.productLoadList();
	}


	//Eğer hasarlı,hasarsız ürün combusu görünür ise buradan seçtikçe ürün listesi tekrar yüklenecek
	//şeçtiği değeri ngModel ile data içerisine basıyoruz.
	onChangeCmbOrderDamageStatus() {

		if(!this.selectedRequestedWareHouseObj)
			return;

		this.shoppingCardService.resetItems();
		this.productLoadList();
	}

	// Kullanıcının talep yapabileceği türde yetkili olduğu depo listesi.
	// loadCmbRequestWarehouses() {

	// 	//Kullanıcı yetkisine göre talep yapılan depoların listesini getiren methoddur.
	// 	this._userPermissionService
	// 		.getFromRequestWarehouseByUserAuths(0)
	// 		.subscribe((wareHouses: WarehouseSelectListDto[]) => {
	// 			console.log(wareHouses);
	// 			this.requestedWarehouseList.next(wareHouses);
				
	// 		});

	// }

	// ABPSession'dan okunamadığı için bu yöntem uygulanmıştır.
	checkUserStockViewAuth() {
		this._userPermissionService.getUserStokViewInformation()
			.subscribe((isStokView: boolean) => {
				this.isStokView.next(isStokView);
			});

	}

	//Paginator işlemleri için gerekli bazı parametreleri buradan sağlıyoruz.
	private paginatorItemParameters(pageIndex, pageSize, keyword) {

		//combobox her değiştirildiğinde elimizde ki product listesinde ki kayıtlı olan
		//pageIndex sıfırlamalıyız yoksa eski page Index kaldığı için product dataları yüklenmiyor.
		this.paginatorBottom.pageIndex = pageIndex;
		this.paginatorBottom.pageSize = pageSize;

		//Bu kullanıcının search alanında aramak istediği kelimeyi sıfırlıyoruz.
		this.keyword = keyword;
	}

	//Talep Yapılan depoya change işlemi olduğunda bu method ile takibini yapıyoruz(en üstteki sabit depo)
	//Talep yapılan depoyu şeçtiğimizde product listesinin gizlenmesi ya da gösterilmesi ve listenin değişmesi gibi...
	onChangeRequestedWareHouse() {
		this.isRequiredRequestedWareHouseMessage.next(false);


		//sepetin içerisini baoşalti diyoruz.
		this.shoppingCardService.resetItems();

		console.log("TALEP YAPILAN DEPOLAR SAYFASINDA CHANGE İŞLEMLERİ.......");
		//Hata mesajının görünmesi için ekledik.
		if (this.selectedRequestedWareHouseObj == -1) {
			this.isRequiredRequestedWareHouseMessage.next(true);
		}

		this.isproductList.next(true);

		////combobox her değiştirildiğinde elimizde ki product listesinde ki kayıtlı olan
		////pageIndex sıfırlamalıyız yoksa eski page Index kaldığı için product dataları yüklenmiyor.
		////Bu kullanıcının search alanında aramak istediği kelimeyi sıfırlıyoruz.
		this.paginatorItemParameters(0,10,"");
		
		//Liste gönderilirken warehouseCode bilgisi gerekli olduğu için eklendi.
		this.wareHouseCode = this.selectedRequestedWareHouseObj.code;
		
		//Warehouse id var ise seçili bir depo vardır ve içeri gir ürün listesini yükle diyoruz.
		var warehouseId = this.selectedRequestedWareHouseObj.id;

		if (warehouseId) {

			this.selectedBusinessUnitId = -1;
			this.selectedBrandUnitId = -1;
			this.selectedSpecialCodeVariationCode = "-1";

			this.brandsByBusinessUnits = new BehaviorSubject<ProductAttributeDto[]>([]);
			this.brandIds = new BehaviorSubject<number[]>([]);
			this.specialCodes = new BehaviorSubject<string[]>([]);

			//Product listesi tekrar yüklemek için kullanıyoruz bu methodu.
			this.productLoadList();
		}
		//depo seçiniz tıklanırsa specialcode, iş birimi ve marka nın içerisini boşalt diyoruz.
		else {

			this.selectedBusinessUnitId = -1;
			this.selectedBrandUnitId = -1;
			this.selectedSpecialCodeVariationCode = "-1";

			this.brandsByBusinessUnits = new BehaviorSubject<ProductAttributeDto[]>([]);
			this.brandIds = new BehaviorSubject<number[]>([]);
			this.specialCodes = new BehaviorSubject<string[]>([]);

			this.isproductList.next(false);

			return;
		}

		//kullanıcının özel kod yetkisi var ise bu methodu çalıştır ve o müşteriye ait özel kodları ekrana bas diyoruz.
		var isCheckedSpecialCode = this.userFormAuthorization$.getValue().isOrderBySpecialCode;
		
		//eğer kullanıcının özel kod yetkisi var ve bir tane depo seçilmiş ise özel kodları comboya doldur diyoruz
		if (isCheckedSpecialCode && this.selectedRequestedWareHouseObj) {
			this.getDistinctSpecialCodesFromWarehousesProductList();
		}
		
	}


	// #endregion

	// #region talep miktarı tutucu


	onBlurOrderQty(product: ProductDto){

		console.log("standart sepete ekleme işlemi:" + product);
			// Ürün stok adeti, stok görme yetkisi olmayan kullanıcılarda null olarak gelir.
			// Null gelen değerlere 0 sayısı set edilir. Böylece stok adeti kontrolü yokmuş gibi sayılır.
		//product.stok = product.stok ? product.stok : 0;
		product.stok = product.stok ? product.stok : 0;

		if (product.stok > 0) { 
		// Stok, talep miktarından büyük olamaz.
			if (product.stok < product.orderedQty) {

			//Eğer kullanıcı stok adedinden fazla talep girerse tıkladığı talep adedi inputunun yerinin değerini
			//tekrar sıfır yap diyoruz.
			product.orderedQty = 0;

			//Eğer daha önceden bu ürüne ait bir kayıt varsa varyasyonuna bakmadan eğer burası sıfırlanmış ise sepet içerisinden silinsi diyoruz.
			this.shoppingCardService.removeProductByProductId(product.id);

				return this.uiMessage.modal.warning(this.customLocalization.l("FE.ALERTMESSAGES.STOCK.HEADER"), this.customLocalization.l("FE.ALERTMESSAGES.STOCK.OVERSTOCK"),null);
			}
		}

			// Ürün sepete eklenmek üzere ilgili servis methodlarına gönderilir.
			this.shoppingCardService.addToCart(product);

	}

	// #endregion

	// #region Dinamic component işlemleri



	//Dynamic componenti oluşturduğumuz method burasıdır.
	//Mesela: Kullanıcı step 2 de nokta ve şahıs adresine talep ederse o sayfanın yüklenmesi için gerekli işlemleri burada yaptırıyoruz.
	private getDynamicComponentByForm(form: UserFormOrderFormTypeDto) {
		var componentFactory;

		var componentName = form.formComponentName;

		console.log("COMPONENT NAME", componentName);

		//Bana gelen component isminin karşılığı olan component objesini değişkene atıyorum.
		let componentNameObj = this.orderService.componentName[componentName];

		//Bunu asenkron kullanmamızın nedeni: adrese talep yapılıyorsa kaydet butonu adrese özel gelmesi
		//gerektiği için yani html kısmında asenkron ngIf yapabilmek için kullanıdım
		this.componentName.next(componentName);

		// Bu componenti çözümlediğim yerdir
		//Componente ait objeleri, bilgileri bulunduran yerdir.
		componentFactory = this.componentFactoryResolve.resolveComponentFactory(
			componentNameObj
		);

		//viewChild ile oluşturduğumuz directive içerisinde ki viewContainer alanını bir değişkene atıyorum.
		let hostViewContainerView = this.orderHost.viewContainerRef;

		//Eger Transfer isleminin componenti ise, ekranin ustunde yer alacagi icin, diger template holder'dan okunur.
		if (this.componentName.getValue() == 'TransferComponent'){
			hostViewContainerView = this.orderTopHost.viewContainerRef

			//Transfer component oldugu icin, "HEDEF DEPO" seklinde UI uzerindeki text degerleri degistirilir.
			this.uiLabelsWarehouse = 'FE.ORDER.FORMS.LABELS.COMMON.TOREQUESTWAREHOUSE'
		}

		hostViewContainerView.clear();

		//Bu viewContainer alanı içerisinde component oluşturuyorum.
		const componentRef = hostViewContainerView.createComponent(componentFactory);

		//this.componentInfo = orderData.component;

		//component içerisinde data alıyorum.
		//dynamic component  içerisinden buraya data alabiliyorum.
		componentRef.instance.dynamicComponentObject.subscribe(
			(dynamicData) => {

				//Dynamic yüklenen data içerisinde gönderilen data objesi.
				this.dynamicCmpObject = dynamicData;

				//Eğer kullanıcı depodan teslim talep yaparsa, talep yapılan depo gösterilmeyecek ve depodan teslim talep de ki datalar
				//talep yapılan depoya akgtarılacak
				if (componentName == 'FromReceiveWarehouseComponent') {

					////Eğer gelen data false bir değer alırsa ürün listesini gizle diyoruz.
					////Mesela: Kullanıcı sadece depoddan teslim talep de lütfen seçiniz şeçerse comboboxlardan product listesini gizle diyoruz.
					if (!this.dynamicCmpObject.requestWarehouse) {

						this.isproductList.next(false);
						this.selectedRequestedWareHouseObj = null;

					
						return;
					}
					////Kullanıcı depodan talep derse ve seçili bir datası varsa buraya gir.
					////Ürün listesini gösteriyoruz ve bilgileri aynen talep yapılan depo objesine setliyoruz.
					////Burası kullanıcı her combobox değiştirdiğinde çalışacağı için keyword, pageIndex ve product sıfırlanarak. liste aktif edildi.
					else {

						

						this.isproductList.next(true);

						this.paginatorItemParameters(0, this.paginatorBottom.pageSize, "");
						
						this.wareHouseCode = this.dynamicCmpObject.requestWarehouse.code;

						this.selectedRequestedWareHouseObj = this.dynamicCmpObject.requestWarehouse;

						this.productLoadList();
					}

				}
				
			}
		);

	}
	
	// #endregion


	//Talep adedi textboxları içerisinde hangilerini disabled edileeceğini belirleriz.
	//Burada eğer varyasyonlu talep yapıldıysa ilgili textbox disabled etmesini söylüyoruz.
	setDisabledOrderQty(productItem){
	
		//tıklanan ürüne ait varyasyonu sıfırdan büyük olanalrı getir diyoruz
		var productObjByVariationId = this.shoppingCartItems$.getValue()
											.find(x => x.variationId > 0 && x.id == productItem.id);

		if(productObjByVariationId){
			return true;
		}
		else {
			return false;

		}
		

	}

	//varyasyonlu talep yapılmış ise(modal içerisinden) 
	//o ürüne ait varyasyonlu kayıtları siliyoruz ortak datamızdan.
	onClickProductOrderQtyDelete(productItem){

		//service içerisinden o ürüne ait tüm varyasyonları olanları siliyoruz.
		this.shoppingCardService.removeProductByProductId(productItem.id);
		
		this.UpdateProductList(productItem.id);

	}

	//varyasyonları silinen ürünü bul ve qty sıfırla ve next ile tekrar yükle diyoruz. 
	UpdateProductList(productId, qty = 0){

		//varyasyonları silinen ürünü bul ve qty sıfırla ve next ile tekrar yükle diyoruz. 
		let product = this.productList.find(x => x.id == productId);

		if(product){

			product.orderedQty = qty;	
			this.products$.next(this.productList);
		}
	}

	//SKT li talep yapmak istersek, yani varyasyonlu talep yapmak istersek kulanıyoruz
	onClickOrderSKT(productItems: ProductDto){
		
		const dialogRef = this._dialog.open(SktLotModalComponent, {
			data: {
				productItems: productItems,
				selectWarehouseObj: this.selectedRequestedWareHouseObj,
				warehouseCode: this.wareHouseCode,
				specialCode: this.selectedSpecialCodeVariationCode,
				orderDamageStatus: this.orderDamageStatusType,
				brandIds: this.brandIds.getValue(),
				stokView: this.isStokView.value
			},
			//hasBackdrop: false,
			disableClose: true
		});

	   //modal içerisinde kaydet tıklatıp kapatırsak, if koşuluna gir ve gönderdiğim dataları setle
	   //ve listeyi tekrar yükle diyoruz. 
	   dialogRef.afterClosed().subscribe(obj =>{

		if(obj){

			if(obj.totalProductVariationOrderQty > 0){
			
				this.UpdateProductList(obj.productId, obj.totalProductVariationOrderQty);
			}

			}
		}
	   )

	}


	// #region Kaydetme İşlemleri (adres Component kaydetme ve diğer componentlerde kaydetme işlemi)

	//Adres componentine özel kaydet butonu
	btnAddressOrderSave() {


		//merkez depodan -> depoya ve distributore talep;
		//Depodan Teslim -> Mobil Depoya ve depoya talep componentlerinin controlunu burada yapıyoruz.
		//(4 Componentin kontrolu buradan yapılıyor.=> warehouse,distribütor, fromReceiveWareHouse, fromReceiveMobilWareHouse)
		if (!this.dynamicCmpObject
			|| !this.dynamicCmpObject.city
			|| !this.dynamicCmpObject.district
			|| !this.selectedRequestedWareHouseObj) {
			//return alert("Lütfen zorunlu alanları doldurunuz");
			return this.uiMessage.modal.error("", this.customLocalization.l("FE.REQUIREDFIELDS.COMMON.REQUIREDFIELDS"), null);

		}




		//Apiye gönderilen talep componentlerinin hepsinde ortak olarak gönderilen datalar.
		var saveOrderData = this.getOrderSaveObject();


		//Product Tablosunda ki stok girilip girilmediğini kontrol eder.
		if (saveOrderData.products.length < 1) {
			return this.uiMessage.modal.error("", this.customLocalization.l("FE.ALERTMESSAGES.STOCK.MINIMUMORDERCOUNT"), null);

			//return alert("En az bir tane stok adedi giriniz");

		}

		//Eğer kullanıcı elle ile lokasyon girer ise bu koşula girer.
		if (!this.dynamicCmpObject.targetAddress) {

			//lokasyon adı ve adresi girmek zorunda.
			if ((!this.dynamicCmpObject.address || !this.dynamicCmpObject.targetCustomAddress)) {
				return this.uiMessage.modal.error("", this.customLocalization.l("FE.REQUIREDFIELDS.COMMON.REQUIREDFIELDS"), null);

				//return alert("lütfen zorunlu alanları doldurunuz");
			}

			//Kullanıcı adres sayfasında elle adres girerse bu method içerisinde işlem yaptırıyoruz.
			this.addressSimilarityOperation(saveOrderData);

		}
		//Kullanıcı lokasyonu direk combobox içerisinden sseçerse bu koşula sokuyoruz.
		else {

			if (!this.dynamicCmpObject.targetAddress) {
				return this.uiMessage.modal.error("", this.customLocalization.l("FE.REQUIREDFIELDS.COMMON.REQUIREDFIELDS"), null);

				//return alert("lütfen zorunlu alanları doldurunuz");

			}
			saveOrderData.toAddressId = this.dynamicCmpObject.targetAddress.id;

			//this.loading.next(true);
			this.orderSave(saveOrderData);

		}

	}

	//adres componenti dışındakiler için kaydet butonu
	btnOrderSave() {


		// //merkez depodan -> depoya ve distributore talep;
		// //Depodan Teslim -> Mobil Depoya ve depoya talep componentlerinin controlunu burada yapıyoruz.
		// //(4 Componentin kontrolu buradan yapılıyor.=> warehouse,distribütor, fromReceiveWareHouse, fromReceiveMobilWareHouse)
		// if (!this.dynamicCmpObject || !this.selectedRequestedWareHouseObj) {
		// 	//return alert("Lütfen zorunlu alanları doldurunuz");
		// 	return this.uiMessage.modal.error("", this.customLocalization.l("FE.REQUIREDFIELDS.COMMON.REQUIREDFIELDS"), null);
		// }
		
	
		// //Apiye gönderilen talep componentlerinin hepsinde ortak olarak gönderilen datalar.
		// var objOrder = this.getOrderSaveObject();

		// //Product Tablosunda ki stok girilip girilmediğini kontrol eder.
		// if (objOrder.products.length < 1) {
		// 	return this.uiMessage.modal.error("", this.customLocalization.l("FE.ALERTMESSAGES.STOCK.MINIMUMORDERCOUNT"), null);
		// }


		// //nokta ve Şahıs Adresine talep sayfasında kaydet işlemi yapmış isek ona özgü dataları burada ekliyoruz.
		// if (this.currentForm.name == "ToRequestSalesStaticLocation") {

		// 	//Adres componentinde ki adres componentine özel olan dataları alır ve kontrol yapar.
		// 	var salesStaticResult = this.salesStaticLocationSendToData(objOrder);
		// 	if (!salesStaticResult) {
		// 		return this.uiMessage.modal.error("", this.customLocalization.l("FE.REQUIREDFIELDS.COMMON.REQUIREDFIELDS"), null);

		// 		//return alert("Lütfen zorunlu alanları doldurunuz");
		// 	}
		// }
		// //Eğer Adres component değilse bu diğer 4 componenti
		// //yani warehouse, mobilwarehouse, distributor, depodan talep
		// //componentlerini temsil etmektedir.o zaman sadece adres id si gereklidir bize. 
		// else {
		// 	//distributor component içerisinde gelen data formatında value olarak geldiği için bu koşulu ekledik.
		// 	if (this.currentForm.name == "ToRequestDistributor") {
		// 		//objOrder.toAddressId = this.dynamicCmpObject.value;
		// 		objOrder.toAddressId = this.dynamicCmpObject.id;

		// 	}
		// 	else if (this.currentForm.name == "FromReceiveWarehouse") {

		// 		if (!this.dynamicCmpObject.requestWarehouse || !this.dynamicCmpObject.receiveWarehouse) {
		// 			return this.uiMessage.modal.error("", this.customLocalization.l("FE.REQUIREDFIELDS.COMMON.REQUIREDFIELDS"), null);

		// 		}

		// 		objOrder.toAddressId = this.dynamicCmpObject.receiveWarehouse.addressId;

		// 	}
		// 	else {
		// 		objOrder.toAddressId = this.dynamicCmpObject.addressId;

		// 	}

		// }

		let objOrder = this.createOrderObject();
		//console.log("OBJ ORDER", objOrder);

		this.orderSave(objOrder);
	}

	createOrderObject() : any {
		//merkez depodan -> depoya ve distributore talep;
		//Depodan Teslim -> Mobil Depoya ve depoya talep componentlerinin controlunu burada yapıyoruz.
		//(4 Componentin kontrolu buradan yapılıyor.=> warehouse,distribütor, fromReceiveWareHouse, fromReceiveMobilWareHouse)
		if (!this.dynamicCmpObject || !this.selectedRequestedWareHouseObj) {
			//return alert("Lütfen zorunlu alanları doldurunuz");
			return this.uiMessage.modal.error("", this.customLocalization.l("FE.REQUIREDFIELDS.COMMON.REQUIREDFIELDS"), null);
		}
		
	
		//Apiye gönderilen talep componentlerinin hepsinde ortak olarak gönderilen datalar.
		var objOrder = this.getOrderSaveObject();

		//Product Tablosunda ki stok girilip girilmediğini kontrol eder.
		if (objOrder.products.length < 1) {
			return this.uiMessage.modal.error("", this.customLocalization.l("FE.ALERTMESSAGES.STOCK.MINIMUMORDERCOUNT"), null);
		}


		//nokta ve Şahıs Adresine talep sayfasında kaydet işlemi yapmış isek ona özgü dataları burada ekliyoruz.
		if (this.currentForm.name == "ToRequestSalesStaticLocation") {

			//Adres componentinde ki adres componentine özel olan dataları alır ve kontrol yapar.
			var salesStaticResult = this.salesStaticLocationSendToData(objOrder);
			if (!salesStaticResult) {
				return this.uiMessage.modal.error("", this.customLocalization.l("FE.REQUIREDFIELDS.COMMON.REQUIREDFIELDS"), null);

				//return alert("Lütfen zorunlu alanları doldurunuz");
			}
		}
		//Eğer Adres component değilse bu diğer 4 componenti
		//yani warehouse, mobilwarehouse, distributor, depodan talep
		//componentlerini temsil etmektedir.o zaman sadece adres id si gereklidir bize. 
		else {
			//distributor component içerisinde gelen data formatında value olarak geldiği için bu koşulu ekledik.
			if (this.currentForm.name == "ToRequestDistributor") {
				//objOrder.toAddressId = this.dynamicCmpObject.value;
				objOrder.toAddressId = this.dynamicCmpObject.id;

			}
			else if (this.currentForm.name == "FromReceiveWarehouse") {

				if (!this.dynamicCmpObject.requestWarehouse || !this.dynamicCmpObject.receiveWarehouse) {
					return this.uiMessage.modal.error("", this.customLocalization.l("FE.REQUIREDFIELDS.COMMON.REQUIREDFIELDS"), null);

				}

				objOrder.toAddressId = this.dynamicCmpObject.receiveWarehouse.addressId;

			}
			else {
				objOrder.toAddressId = this.dynamicCmpObject.addressId;

			}

		}

		return objOrder ;
	}

	

	//Kullanıcı elle adres girdi önce benzeşen adres var mı diye bakıyoruz.
	//Eğer benzer adres yoksa doğrudan kaydet diyoruz.
	//Eğer benzeşen adres varsa modal aç ve uygun olan adresin varsa seç ya da benzeşen adresim yok kısmına
	//tıklayarak kendi eklediğin adresi kaydede bilirsin
	addressSimilarityOperation(saveOrderData) {

		//Kullanıcın girdiği lokasyon ve o lokasyona ait açık adresi ekliyoruz.
		let addressInfo = new AddressSimilarityDto();
		addressInfo.name = this.dynamicCmpObject.targetCustomAddress;
		addressInfo.fullAddress = this.dynamicCmpObject.address;

		//lokasyonve adres textboxı içerisinde girilen dataları benzerlerini getiren methoddur
		this._addressService.checkSimilarityAddresses(addressInfo, this.dynamicCmpObject.city)
			.subscribe((addressList: AddressSimilarityResultDto[]) => {

				//kullanıcı elle adres girdi ancak hiç benzer adres yok ise otomatik olarak kaydet diyoruz.
				if (addressList.length == 0) {

					let newAddressInfo = new AddressDto();

					newAddressInfo.cityId = this.dynamicCmpObject.city;
					newAddressInfo.districtId = this.dynamicCmpObject.district;
					newAddressInfo.name = addressInfo.name;
					newAddressInfo.fullAddress = addressInfo.fullAddress;


					saveOrderData.newAddressDto = new OrderNewAddressDto({ address: newAddressInfo, isValidAddress: false });

					//Kaydetme işlemini yaptığımız methodumuzdur.
					this.orderSave(saveOrderData);
			
				}
				//Eğer kullanıcının elle girdiği adresin benzer adresleri var ise bu modal aç ve listele diyoruz.
				else {
					let criticalSimilarAddressIdList = [];

					addressList.forEach(address => {
						if (address.isCriticalSimilarity == true) {
							criticalSimilarAddressIdList.push(address.id);
						}
					});


					var dialofRef = this._dialog.open(AddressSimilarityModalComponent, {
						data: {
							addressInfo: addressInfo,
							saveOrderData: saveOrderData,
							cityId: this.dynamicCmpObject.city,
							districtId: this.dynamicCmpObject.district,
							addressList: addressList,
							criticalSimilarAddressIdList: criticalSimilarAddressIdList
						}


					})

					
					

					dialofRef.afterClosed().subscribe(saveOrderData => {
						console.log("adres kaydetme işlemini yapıyorum fakat obje geliyor mu?");
						if (saveOrderData) {
							this.orderSave(saveOrderData);

						}

					})

					////////////////////////////////////////////////////////////
					//let criticalSimilarAddressIdList = [];

					////modal açtık
					////adressimilaritymodalcomponentini modal içerisine yükle dedik.
					//const modalRef = this.modalService.open(AddressSimilarityModalComponent, {
					//	size: 'xl'
					//});


					////Modal içerisine göndereceğimiz datalar
					//modalRef.componentInstance.addressInfo = addressInfo;
					//modalRef.componentInstance.saveOrderData = saveOrderData;
					//modalRef.componentInstance.cityId = this.dynamicCmpObject.city;
					//modalRef.componentInstance.districtId = this.dynamicCmpObject.district;
					//modalRef.componentInstance.addressList = addressList;

					//addressList.forEach(address => {
					//	if (address.isCriticalSimilarity == true) {
					//		criticalSimilarAddressIdList.push(address.id);
					//	}
					//});

					//modalRef.componentInstance.criticalSimilarAddressIdList = criticalSimilarAddressIdList;


					
				}
			})
	}

	//Tüm komponentlerde ortak olarak gönderilen datalar
	private getOrderSaveObject(): CreateOrderDto {

		var objOrder = new CreateOrderDto();

		objOrder.fromWarehouseId = this.selectedRequestedWareHouseObj.id;
		objOrder.fromAddressId = this.selectedRequestedWareHouseObj.addressId;
		objOrder.fromWarehouseCode = this.wareHouseCode;
		//objOrder.remoteWarehouseId = this.selectedRequestedWareHouseObj.remoteWarehouseId;
		objOrder.componentType = this.currentForm.id;
		objOrder.products = this.shoppingCartItems$.getValue().filter(x => x.orderedQty > 0);
		objOrder.shipmentType = this.selectedShipmentType;
		objOrder.isOrderByVariation = this.selectedSpecialCodeVariationCode == "-1" ? false : true;
		objOrder.specialCode = this.selectedSpecialCodeVariationCode == "-1" ? null : this.selectedSpecialCodeVariationCode;

		//Comment Sonradan eklendi. 06.10.2021 - Hasan
		objOrder.comment = this.comment ;

		//objOrder.remoteWarehouseCode = this.selectedRequestedWareHouseObj.remoteWarehouseCode;
		if (this.orderDamageStatusType != 2) {
			objOrder.productDamageStatusType = this.orderDamageStatusType;
		}

		return objOrder;
	}

	//Nokta ve şahıs adresi sayfası için gönderilen extra datalar.
	private salesStaticLocationSendToData(saveOrderData): boolean {


		if (
			
			//Alici telefonNo ve alici adSoyad bilgisi zorunlulu Mahmut'un talebi uzerine 10.10.2022 tarihinde kaldirildi.
			
			//!this.dynamicCmpObject.salesPhone
			//|| !this.dynamicCmpObject.salesUserName
			 
			
			!this.dynamicCmpObject.targetAddressObject
		) {
			return false;

		}

		saveOrderData.receiverName = this.dynamicCmpObject.salesUserName;
		//saveOrderData.receiverPhone = this.dynamicCmpObject.salesPhone;
		saveOrderData.receiverPhone = this.phoneNumberEdit();
		saveOrderData.toAddressId = this.dynamicCmpObject.targetAddressObject.id;

		return true;

	}

	private phoneNumberEdit(): any {

		var phoneNumber = this.dynamicCmpObject.salesPhone;
		phoneNumber = phoneNumber.replace(/\(/g, '');
		phoneNumber = phoneNumber.replace(/\)/g, '');
		phoneNumber = phoneNumber.replace(/\-/g, '');
		phoneNumber = phoneNumber.replace(/\ /g, '');

		console.log(phoneNumber);
		return phoneNumber;
	}

	//yetersi stoğu olan ürünleri göstermek için kullanırız.
	stockControlResult = []; 
	insufficienStockIndicator(productId: number) {

		//console.log("Yetersiz stok kontrolune bakıyoruz......................");
		var isProductObj = this.stockControlResult.find(x => x.productId == productId);

		if (isProductObj) {
			return true;
		}

		return false;
	}

	/**
	 * Talep edilecek urunlerin tahmini sevk maliyetini gosterir.
	 */
	calculateShipmentPrice(){
		//Apiye gönderilen talep componentlerinin hepsinde ortak olarak gönderilen datalar.
		var objOrder = this.createOrderObject();
		
		if (objOrder)
		{
			this._orderService.calculateShipmentPrice(objOrder)
				.subscribe(res => {
					let totalPrice = 0;

					res.forEach((x, i) => {
						totalPrice += x.totalPrice ;
					});
					
					this.uiMessage.modal.info(totalPrice.toFixed(0).toLocaleString() + " TL", "Yaklaşık sevk maliyetidir. Ürünlerin taşınması esnasında kullanılan paketleme yöntemlerine göre değişkenlik gösterebilir.", null);
				});
		}

		
	}

	//Kaydetme işleminin yapıldığı api methodu
	private orderSave(saveOrderData) {

		this._orderService.createOrderProduct(saveOrderData)
			 .subscribe(res => {

					if(res.isValid){
						//Eğer yetersiz stoklar düzeltildiyse 
						this.stockControlResult = [];
						//İşlem başarılıysa kayıtlı talep miktarlarını sıfırlıyoruz.
						this.orderService.productList = [];
   
						this.uiMessage.modal.success("", this.customLocalization.l("FE.ALERTMESSAGES.COMMON.SUCCESSPROCESS"), () => {
							window.location.reload();
						});
					}
					else{

						if(res.unStockProducts.length > 0){
							//Modal açılacak ve içerisine datalar uygun formatta basılacak.
							var dialogRef = this._dialog.open(InsufficientStockModalComponent, {
								data: { products: res.unStockProducts }
	
							})
	
							dialogRef.afterClosed().subscribe(insuffucientStoks => {
	
								console.log("Yetersiz stok listesi" + insuffucientStoks);
	
								this.stockControlResult = res.unStockProducts;
	
								this.mergeProductWithShoppingCarts(this.productList);
								this.products$.next(this.productList);
								
								//İşlem başarılıysa kayıtlı talep miktarlarını sıfırlıyoruz.
								//this.orderService.productList = [];
	
								//this.uiMessage.modal.error("", "Bu Ürünlere Yeterli Stok Adedi Bulunmamaktadır", () => {
								// //sayfayı yeniden yükle.
								// //window.location.reload();
								//});
	
	
							})
						}
						else{

							let errMsg = res.userFriendlyMessage ? res.userFriendlyMessage : this.customLocalization.l("ERRORMODAL.ERRORCODE.EXPLANITON")

							this.uiMessage.modal.error("", errMsg , () => {
								//window.location.reload();
							});
						}

						
					}


					 
				}, (error)=>{
					console.log("orderSave error!");
				  }, ()=>{
					console.log("Final");
				  });

	}


	// #endregion
	
	// #region Paginator işlemleri(ürün listesi için kullnılan)

	//Product tablosunun üzerinde ki serach yerinde arama yaptığımız da bu methoda giriyoruz.
	//Kullanıcı bir şeyler yazdığında 5 saniyelik bir sürede sonunda o yazdığı kelimeyi arka tarafa göndererek tekrar
	//product listesini yüklüyoruz.
	productSearchOperation() {

		const searchSubscription = fromEvent(
			this.searchInput.nativeElement,
			"keyup"
		)
			.pipe(
				debounceTime(500), //Kullanıcı search yerine tıklayıp ilk harfi yazdıktan sonra arka tarafa gitmeden önce beklenecek olan süredir.
				distinctUntilChanged(),
				tap(() => {

					if (this.keyword.replace(/\s/g, "").length < 1 && this.keyword.indexOf(' ') >= 0) {
						return;
					}

					//Kullanıcı arama yaptığında bizim
					//tekrar product listesinin ilk sayfasında gitmemiz gerek.Çünki aranan kelimeleri ilk sayfaya basıyoruz.
					this.paginatorBottom.pageIndex = 0;

					

					//paginator ilk sayfaya getirdikten sonra yazılan kelimeyi tekrar arka tarafa
					//gönderdiğimiz ve listeyi tekrar yüklediğimiz method.
					this.productLoadList();
				})
			)
			.subscribe();

		this.subscriptions.push(searchSubscription);
	}

	//prduct listesinin yüklendiğinde yüklenecek data sayılarını, sayfa geçişlerini yönettiğimiz yerdir.
	//page işlemi yapıldığında buraya girer (mesela 5 değilde 10 lu görünsün dediğimizde.)
	productPaginatorOperation() {

		const paginatorSubscriptions2 = merge(
			this.paginatorBottom.page
		)
			.pipe(
			tap(() => {

				this.paginatorItemParameters(this.paginatorBottom.pageIndex, this.paginatorBottom.pageSize, this.keyword);
					////Bir sayfada görünecek olan product sayısını temsil eder. Mesela: ilk 5 ya da 10 tanesi gibi.
					//this.paginatorBottom.pageSize = this.paginatorBottom.pageSize;

					////porduct listesinde ki bulunduğumuz dilimi temsil eder.
					////Mesela: pageIndex = 2 yani product listesini ikinci 10 tanesini getir demektir.
					//this.filterParams.pageIndex = this.paginatorBottom.pageIndex;

				this.productLoadList();
				})
			)
			.subscribe();
		this.subscriptions.push(paginatorSubscriptions2);

	}

	// #endregion
	
	// #region Ürün listesi yükleme


	//product listesini yüklediğimiz yerdir.
	//Productlistesinde basılacak elemanların getirildiği methoddur.
	productLoadList() {
		this.productNotFound.next(false);

		//Arka tarafa gönderilecek olan paramatreler bulunur.
		//Mesela: kullanıcı search yerine keyword girerse bu keyword göre filtreli datalar gelir.
		this.filterPrepare();
		const filter = this.filterParams;

		const skipCount =
			filter.pageIndex *
			(filter.maxResultCount ? filter.maxResultCount : 0);

		
		
		//Kullanıcının yetkili olduğu depolardan birini seçtiğinde o depoya karşılık düşen ürün listesini bize döndürür.
		this._productService
			.getFormWarehouseProductListByUserAuths(
			this.selectedRequestedWareHouseObj.id,
			this.wareHouseCode,
			//this.selectedRequestedWareHouseObj.remoteWarehouseId,
			this.selectedSpecialCodeVariationCode == "-1" ? "" : this.selectedSpecialCodeVariationCode,
			this.brandIds.getValue(),
			this.orderDamageStatusType,
				filter.keyword,
				filter.sorting,
				skipCount,
			filter.maxResultCount,
			this.currentForm.id
			)
			.subscribe(
			(productDto) => {

					console.log(productDto);
					var products = productDto.items;

					this.mergeProductWithShoppingCarts(products);

					this.products$.next(products);
					this.productList = products;
					this.totalCount$.next(productDto.totalCount);

					this.checkProductsLength(products, filter.keyword);
			}, error => {

				this.selectedRequestedWareHouseObj = null;

				this.selectedBusinessUnitId = -1;
				this.selectedBrandUnitId = -1;
				this.selectedSpecialCodeVariationCode = "-1";

				this.brandsByBusinessUnits = new BehaviorSubject<ProductAttributeDto[]>([]);
				this.brandIds = new BehaviorSubject<number[]>([]);
				this.specialCodes = new BehaviorSubject<string[]>([]);

				this.isproductList.next(false);


			});
	}


	// Filtrelemelere göre gelen ürün listesi ile daha önceden sepete eklenmiş ürünleri merge eder.
	// Ürün listesine ait sepette ürün var ise, ilgili ürünlerin talep miktarlarını sepetteki ürün miktarları ile günceller.
	private mergeProductWithShoppingCarts(products: ProductDto[]) {

		//Dönen ürün listemiz içerisinde gez.
		//eğer kayıtlı data içerisinde bu ürün id ve varyasyon id varsa talep adedi içerisine setle diyoruz
		//eğer kayıtlı data içerisinde bu ürün id ve varyasyonId si 0 dan 
		//büyük olan varsa ki bu durum varyasyonlu taleptir, bu varyasyonlu talepte ki ürün toplamını 
		//talep adedi içerisine yaz diyoruz
		products.forEach(product => {

			//ürün listesin deki ürünün bizim ortak objemizde ki id leri
			//aynı ve varyasyon id leri aynı ise talep adedine kayıtlı olan talep miktarını ata diyoruz
			let currentProduct = this.shoppingCartItems$.getValue().find(x=> x.id == product.id && x.variationId == product.variationId);
			if(currentProduct){
				product.orderedQty = currentProduct.orderedQty;
			}
			
			//ürün listesin deki ürünün bizim ortak objemizde ki id leri
			//aynı ve varyasyon id leri sıfırdan büyükse bu bir varyasyonlu taleptir 
			//ise talep adedine kayıtlı olan talep miktarının toplamını ata diyoruz 
			let currentProductByVariationIdGreaterThenZero = this.shoppingCartItems$.getValue()
									.filter(x=> x.id == product.id && x.variationId > 0);
				
			//Eğer kullanıcının skt li yani varyasyonu olan bir talep adedi girildi ve ortak dataya 
			//eklendiyse bunları toplamını alıyoruz ve toplamını ürün listesine yazıyor ve disabled ediyoruz.						
			if(currentProductByVariationIdGreaterThenZero.length > 0){
				var sum = 0;

				currentProductByVariationIdGreaterThenZero.forEach(x => {

					sum += (+x.orderedQty);
				})

				product.orderedQty = sum;
			}
			
			
		})
	}

	private checkProductsLength(products : ProductDto[], keyword : string){
		// Listeden gelen ürün adedi 1'den küçük ise Ürün Bulunamadı hatası verir.
		if (products.length < 1) {
				this.productNotFound.next(true);
		}
	}



	// #endregion

	// #region Ürün listesi filtreleme parametleri

	//apiye gönderilecek filtre parametrelerini burada belirliyoruz.
	//ürün listesi getirilmeden önce bu filtrelere göre bize data gönderiliyor.
	filterPrepare() {

		
		//sıralama isim'e göre yapıldı.
		this.filterParams.sorting = "Name asc";

		this.filterParams.maxResultCount = this.paginatorBottom.pageSize; //Bir sayfada gorunebilecek en fazla kayit sayisi.

		//bulunduğu aralığını temsil eder. 100 ürün bulunan listenin 20 ile 30 datalarını yani page index 2 getirir.
		this.filterParams.pageIndex = this.paginatorBottom.pageIndex;

		//search işleminin yapıldı yeri temsil eder. eğer kullanıcı ürünler arasında bir isim aramak isterse keywor içerisine yazarız.
		this.filterParams.keyword = this.keyword
			.replace(/i/g, "ı")
			.toLocaleUpperCase().trim();
	}

	// #endregion


	getPhotoUrl(kod: string): string {

		return  AppConsts.productImage.url + '/' + kod + '.jpg';

	}

	//Product listesinin üzerinde ki resimlere tıklayınca buradan code göre url oluşturup modal açıp içine basıyoruz.
	openProductImage(productCode, pName) {

		let imgActualSize = ( AppConsts.productImage.url + '/large/' + productCode + '.jpg');

		const modalRef = this.modalService.open(ImageModalComponent, {
			size: 'md'
		});

		modalRef.componentInstance.imgActualSize = imgActualSize;
		modalRef.componentInstance.productCode = productCode;
		modalRef.componentInstance.productName = pName;
	}

	ngOnDestroy() {

		this._testService.setTitle(" ");
		this._testService.setDesc(" ");

		this.loading$.unsubscribe();
		this.requestedWarehouseList.unsubscribe();
		this.products$.unsubscribe();
		this.totalCount$.unsubscribe();
		this.loading$.unsubscribe();
		this.componentName.unsubscribe();
		//this.loading.unsubscribe();
		this.isStokView.unsubscribe();
		this.isproductList.unsubscribe();
		this.routeSub.unsubscribe();
		//this.shoppingCartItems$.();
	}
}
